<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
import axios from "axios";
export default {
    name: "Detail",
    data() {
        return {
            detailIndex: null,
            start_date: '',
            end_date: '',
            maxDate: '',
            transactions: [],
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        hostUrl() {
            return this.$store.state.hostUrl;
        },
    },
    watch: {
        userNbInfo: function () {
            const _this = this;
            if (!_this.userNbInfo.data.user.isBind) {
                _this.$router.push("/welcome");
            }
        },
    },
    mounted() {
        const _this = this;
        const today = new Date();
        const format = d => d.toISOString().split('T')[0];
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        _this.end_date = format(yesterday);
        _this.maxDate = format(yesterday);
        const threeMonthsAgo = new Date(yesterday);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        _this.start_date = format(threeMonthsAgo);

        nextTick(() => {
            // let vm = this;
            if (_this.userNbInfo.data) {
                if (!_this.userNbInfo.data.user.isBind) {
                    _this.$router.push("/welcome");
                }
            }
        });
        _this.getTransaction()
    },
    methods: {
        validateEndDate() {
            if (this.end_date > this.maxDate) {
                alert('僅提供前一日以前的查詢');
                this.end_date = this.maxDate;
            }
        },
        changeToLocaleString(str) {
            return typeof str === "number" ? str.toLocaleString() : 0;
        },
        showFullInfo(index) {
            // console.log("showFullInfo");
            const _this = this;
            if (index === _this.detailIndex) {
                _this.detailIndex = null;
            } else {
                _this.detailIndex = index;
            }
        },
        getTransaction(){
            const _this = this;
            if (_this.start_date > _this.end_date) {
                alert('開始日期不能大於結束日期');
                return;
            }
            _this.$store.commit("loadingToggle", true);
            axios.get(`${_this.hostUrl}member/transactions`, {
                headers: {
                    Authorization: `Bearer ${_this.$store.state.userNbInfo.access_token}`,
                },
                params: {
                    start_date: _this.start_date,
                    end_date: _this.end_date,
                },
            }).then(response => {
                console.log(response.data.data.transactions)
                _this.transactions = response.data.data.transactions;
                nextTick(() => {
                    _this.$store.commit("loadingToggle", false);
                });
            }).catch(error => {
                console.error(error);
            });
        }
    },
};
</script>
<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
